export default __webpack_public_path__ + "static/media/sort-asc.552e6d3a.svg";